import { render, staticRenderFns } from "./EmailTemplateForm.vue?vue&type=template&id=54d8ea37&"
import script from "./EmailTemplateForm.vue?vue&type=script&lang=js&"
export * from "./EmailTemplateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports